@for (extra of extras(); track extra.extrasFileName) {
    <asset-episode-card [extrasItem]="$any(extra)" data-testid="details_episode-item"
        (onPlay)="playExtra.emit(extra)"></asset-episode-card>
}
